import { Col, Row } from "react-bootstrap";
import StyledText from "../../components/StyledComponents/StyledText";
import AddFolderIcon from "../../assets/icons/AddFolderIcon";
import { CorporateTheme, darkTheme, font, Theme } from "../../utils/themes";
import FolderIcon from "../../assets/icons/FolderIcon";
import ChevronDownIcon from "../../assets/icons/ChevronDownIcon";
import { ChevronWrapper } from "../../components/form/CustomSelect";
import styled from "styled-components";
import ShareLinkIcon from "../../assets/icons/ShareLinkIcon";
import EditIcon from "../../assets/icons/EditIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import { Button } from "../../components/form/Button";
import FormsIcon from "../../assets/icons/FormsIcon";
import Pagination from "../../components/listing/Pagination";
import ComponentHeader from "../../components/ComponentHeader/ComponentHeader";
import { useEffect, useId, useRef, useState } from "react";
import {
  useAddNewFolderMutation,
  useCloneQueryMutation,
  useDeleteQueryFolderMutation,
  useDeleteQueryMutation,
  useGetAllQueriesQuery,
  useGetQueriesByFolderIdMutation,
  useGetQueryFoldersQuery,
  useUpdateFolderMutation,
} from "../../api/searchQueryApiSlice";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikInputField from "../../components/Formik/FormikInputField";
import CrossIcon from "../../assets/icons/CrossIcon";
import OpitonsIcon from "../../assets/icons/OptionsIcon";
import RenameIcon from "../../assets/icons/RenameIcon";
import { useToast } from "../../components/toast/ToastContext";
import LoadingCircleIcon from "../../assets/icons/LoadingCircleIcon";
import DeletePrompt from "../../components/DeletePrompt";
import { useDispatch } from "react-redux";
import { setQueryFolders } from "./QuerySlice";
import { SkeletonCell } from "../../components/SkeletonCell";
import { useLocation, useNavigate } from "react-router-dom";
import NoData from "../../components/listing/NoData";
import ClockIcon from "../../assets/icons/ClockIcon";
import ScheduleQueryModal from "./ScheduleQueryModal";
import { useTheme } from "../../middleware/ThemeContext";
import { capitalizeFirstLetter, formatDateDefault, hexToRgba } from "../../utils/helper";
import { StyledHorizontalLine } from "../../components/StyledComponents/Styledhr";
import SimpleBar from "simplebar-react";
import CopyIcon from "../../assets/icons/CopyIcon";
import Badge from "../../components/Badge";
import NewCopyIcon from "../../assets/icons/NewCopyIcon";
import PlayIcon from "../../assets/icons/PlayIcon";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import moment from "moment";
import CheckListIcon from "../../assets/icons/CheckListIcon";
import EditCalendarIcon from "../../assets/icons/EditCalendarIcon";
import SearchCalendarIcon from "../../assets/icons/SearchCalendarIcon";
import OutlineUserIcon from "../../assets/icons/OutlineUserIcon";

interface QueryFolder {
  id: number;
  name: string;
  type: string;
  companyId?: number;
  parentFolderId?: number | null;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: number;
  children?: QueryFolder[];
  grandChildren?: QueryFolder[];
}

interface FoldersData {
  totalCount?: number;
  queryFolders?: QueryFolder[];
}

type FolderProps = {
  folder: QueryFolder;
  queryId: QueryFolder | null;
  setQueryId: (id: QueryFolder) => void;
  getQueriesCall: (id: number) => void;
  isDisabled?: boolean;
};

const QueryFoldersListing = () => {
  const { theme } = useTheme();
  const userID = JSON.parse(
    localStorage.getItem("authData") || "{}"
  )?.userId;
  const [createFolder, setCreateFolder] = useState(false);
  interface QueriesData {
    searchTemplates?: any[];
    totalCount?: number;
    perPage?: number;
    page?: number;
  }
  const showToast = useToast();
  const dispatch = useDispatch();
  const location = useLocation();
  const paramID = location.state?.paramId;

  const navigate = useNavigate();
  const optionsRef = useRef<HTMLDivElement>(null);
  const createNewFolderRef = useRef<HTMLDivElement>(null);
  const [getQueries, { isLoading: queryLoading }] =
    useGetQueriesByFolderIdMutation();
  const [addNewFolder, { isLoading: addFolderLoading }] =
    useAddNewFolderMutation();
  const [updateFolderName, { isLoading: updateFolderLoading }] =
    useUpdateFolderMutation();
  const [deleteQueryFolder, { isLoading: folderDeleteLoading }] =
    useDeleteQueryFolderMutation();
  const [deleteQuery, { isLoading: queryDeleteLoading }] =
    useDeleteQueryMutation();
  const [cloneQuery] = useCloneQueryMutation();
  const [queriesData, setQueriesData] = useState<QueriesData>({});
  const [queryId, setQueryId] = useState<QueryFolder | null>({
    id: 786,
    name: "ALL QUERIES",
    type: "ALL QUERIES",
    parentFolderId: null,
    children: [],
  });
  const [parent, setParent] = useState<QueryFolder | null>(null);
  const [activeSource, setActiveSource] = useState<
    "ALL" | "FOLDER"
  >("ALL");
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [showDeleteQueryPrompt, setShowDeleteQueryPrompt] = useState(false);
  const [deleteQueryId, setDeleteQueryId] = useState<{
    deleteId?: number;
    folderId?: number;
  }>({});
  const [updateFolder, setUpdateFolder] = useState<QueryFolder | null>(null);
  const [openFolders, setOpenFolders] = useState<Record<number, boolean>>({});
  const [openOptions, setOpenOptions] = useState<Record<number, boolean>>({});
  const [createNewFolder, setCreateNewFolder] = useState(false);
  const [scheduleId, setScheduleId] = useState("");
  const [scheduledModal, setScheduledModal] = useState(false);
  const [queryName, setQueryName] = useState("");
  const [queryType, setQueryType] = useState<string | undefined>(undefined);
  const [sorting, setSorting] = useState<{ sort?: string; sortDir?: string }>({
    sort: undefined,
    sortDir: undefined,
  });
  const [folderData, setFolderData] = useState<FoldersData | null>(null);
  const totalPages = Math.ceil(
    (queriesData?.totalCount ?? 0) / (queriesData.perPage ?? 1)
  );

  const formatScheduleLabel = (settings: any) => {
    if (!settings) return "";
    const freq = (settings.frequency || "").toString().toUpperCase();

    if (freq === "HOURLY") {
      const n = Number(settings.intervalHours) || 1;
      return `Every ${n} ${n > 1 ? "Hours" : "Hour"}`;
    }

    if (freq === "DAILY") {
      const t = settings.timeOfDay;
      return t ? `Every day @ ${moment(t, "HH:mm").format("hh:mm A")}` : "Every day";
    }

    if (freq === "WEEKLY") {
      const days = settings.daysOfWeek;
      const map = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];
      if (Array.isArray(days) && days.length) {
        const orderedDays = [...days]
          .map((d: any) => Number(d))
          .filter((d: number) => !Number.isNaN(d))
          .sort((a: number, b: number) => a - b);
        const names = orderedDays.map((d: number) => map[d] || d).join(", ");
        const t = settings.timeOfDay;
        return t ? `${names} @ ${moment(t, "HH:mm").format("hh:mm A")}` : `${names}`;
      }
      return "Weekly";
    }

    if (freq === "MONTHLY") {
      const day = settings.dayOfMonth?.value ?? settings.dayOfMonth;
      const t = settings.timeOfDay;
      const ordinal = (n: any) => {
        const num = Number(n);
        if (Number.isNaN(num)) return n;
        const j = num % 10, k = num % 100;
        if (j === 1 && k !== 11) return `${num}st`;
        if (j === 2 && k !== 12) return `${num}nd`;
        if (j === 3 && k !== 13) return `${num}rd`;
        return `${num}th`;
      };
      return day ? `Every month on the ${ordinal(day)}${t ? ` @ ${moment(t, "HH:mm").format("hh:mm A")}` : ""}` : "Monthly";
    }

    return settings.frequency ? capitalizeFirstLetter(settings.frequency.toString().toLowerCase()) : "";
  };

  const getScheduleBadgeLabel = (item: any) => {
    const nextExecution = item?.scheduledQuery?.nextExecutionDate;
    const lastRunAt = item?.scheduledQuery?.lastRunDate;

    if (nextExecution && !lastRunAt) {
      return "Scheduled";
    }
    if (nextExecution && lastRunAt) {
      return "Scheduled & Running";
    }
    if (!nextExecution && lastRunAt) {
      return "Completed & Inactive";
    }
    return "Inactive";
  };

  const [initialFilters, setInitialFilters] = useState<{
    query: string | undefined;
    filters: { startDate: string | undefined; endDate: string | undefined };
    scheduled: boolean | undefined;
    scope?: undefined | string;
  }>({
    query: undefined,
    filters: { startDate: undefined, endDate: undefined },
    scheduled: undefined,
    scope: undefined,
  });

  const {
    data: folders,
    refetch,
    isFetching,
    isLoading: foldersLoading,
  } = useGetQueryFoldersQuery(
    {},
    {
      refetchOnMountOrArgChange: true,
    }
  );



  const hasValidDateRange =
    initialFilters?.filters?.startDate && initialFilters?.filters?.endDate;

  const {
    data: queries,
    refetch: refetchAllQueries,
    isFetching: allQueriesFetching,
  } = useGetAllQueriesQuery(
    {
      ...(queryType !== undefined ? { queryType } : {}),
      ...(initialFilters?.query !== undefined
        ? { query: initialFilters?.query }
        : {}),
      ...(initialFilters?.scope !== undefined
        ? { scope: initialFilters?.scope }
        : {}),
      ...(initialFilters?.scheduled !== undefined
        ? { scheduled: initialFilters?.scheduled }
        : {}),
      ...(hasValidDateRange
        ? {
          lastRunStartDate: initialFilters.filters.startDate,
          lastRunEndDate: initialFilters.filters.endDate,
        }
        : {}),

      ...(sorting.sort ? { sort: sorting.sort } : {}),
      ...(sorting.sortDir ? { sortDir: sorting.sortDir } : {}),
      page: queriesData?.page ?? 1,       // 🔹 add current page
      perPage: queriesData?.perPage ?? 10 // 🔹 add per-page limit
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const getQueriesCall = (id: any, page: number = 1, perPage: number = 10) => {
    setActiveSource("FOLDER");
    const call = getQueries;
    try {
      call({ id, page, perPage }).then(({ data }: any) => {
        if (data) {
          setQueriesData(data);
          //   updateFolderChildren(id, data.children);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenOptions({});
          setCreateNewFolder(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(
    (openOptions && optionsRef) || (createNewFolder && createNewFolderRef)
  );

  const isFetchingData: boolean = allQueriesFetching || queryLoading;

  const FolderItem = ({
    folder,
    queryId,
    setQueryId,
    getQueriesCall,
    openFolders,
    setOpenFolders,
    level,
    parentFolder = null, // <- New
    isDisabled
  }: FolderProps & {
    openFolders: Record<number, boolean>;
    setOpenFolders: React.Dispatch<
      React.SetStateAction<Record<number, boolean>>
    >;
    openOptions: Record<number, boolean>;
    setOpenOptions: React.Dispatch<
      React.SetStateAction<Record<number, boolean>>
    >;
    level: number;
    parentFolder?: QueryFolder | null;
  }) => {

    const hasChildren =
      (level === 1
        ? folder?.grandChildren?.length ?? 0
        : folder?.children?.length ?? 0) > 0 &&
      (level === 1 ? folder?.grandChildren ?? [] : folder?.children ?? []).some(
        (child) => !child?.isDeleted
      );
    const isOpen = openFolders[folder?.id] ?? false;
    const isOptionOpen = openOptions[folder?.id] ?? false;

    const toggleOptions = () => {
      setOpenOptions({ [folder.id]: !isOptionOpen });
    };

    const handleClick = () => {
      getQueriesCall(folder.id);
      setQueryId(folder);
    };

    const toggleOpen = () => {
      setOpenFolders((prev) => ({
        ...prev,
        [folder.id]: !isOpen,
      }));
    };

    interface Option {
      name: string;
      icon: React.ReactNode;
      handler: (fold: QueryFolder) => void;
    }

    let Options: Option[] = [];

    if (level === 0) {
      Options = [
        {
          name: "Add Folder",
          icon: <AddFolderIcon color={theme.CorporateTheme.colors.textSecondary} size={18} />,
          handler: (fold: any) => {
            setParent(fold);
            setCreateNewFolder(true);
            toggleOptions();
          },
        },
      ];
    } else if (level === 1) {
      Options = [
        {
          name: "Rename",
          icon: <RenameIcon color={theme.CorporateTheme.colors.gunmetal} size={16} />,
          handler: (fold: any) => {
            setUpdateFolder(fold); // Current folder to rename
            if (fold?.parentFolderId === parentFolder?.id) {
              setParent(parentFolder); // Set its actual parent
            }
            setCreateNewFolder(true); // Show rename form
            toggleOptions();
          },
        },
        {
          name: "Delete",
          icon: <DeleteIcon color={theme.CorporateTheme.colors.gunmetal} size={18} />,
          handler: (fold: any) => {
            setQueryId(fold);
            setShowDeletePrompt(true);
            setCreateNewFolder(false);
            toggleOptions();
          },
        },

        {
          name: "Add folder",
          icon: <AddFolderIcon color={theme.CorporateTheme.colors.gunmetal} size={18} />,
          handler: (fold: any) => {
            setParent(fold);

            setCreateNewFolder(true);
            toggleOptions();
          },
        },
      ];
    } else if (level === 2) {
      Options = [
        {
          name: "Rename",
          icon: <RenameIcon color={theme.CorporateTheme.colors.textSecondary} size={16} />,
          handler: (fold: any) => {
            setUpdateFolder(fold); // Current folder to rename
            setParent(parentFolder); // Set its actual parent
            setCreateNewFolder(true); // Show rename form
            toggleOptions();
          },
        },
        {
          name: "Delete",
          icon: <DeleteIcon color={theme.CorporateTheme.colors.textSecondary} size={18} />,
          handler: (fold: any) => {
            setQueryId(fold);
            setShowDeletePrompt(true);
            setCreateNewFolder(false);
            toggleOptions();
          },
        },
      ];
    }

    return (
      <div className="px-3 mt-1">
        <StyledFolderBar
          theme={theme}
          className={`d-flex pe-2  align-items-center justify-content-between cursor-pointer ${folder.id === queryId?.id ? "active" : ""
            }`}

        >
          {/* Left side: Folder icon and name */}
          <div className={`d-flex align-items-center ps-2 py-2 gap-2 w-100 ${isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
            // onClick={() => {
            //   if (folder?.name === "ALL QUERIES") {
            //     setQueryType(undefined);
            //     setSorting({ ...sorting, sort: undefined, sortDir: undefined });
            //     setInitialFilters({ ...initialFilters, scheduled: undefined });

            //     queryType === undefined &&
            //       sorting?.sort === undefined &&
            //       sorting?.sortDir === undefined &&
            //       refetchAllQueries().then((res) => {
            //         if ("data" in res && res.data?.searchTemplates) {
            //           setQueriesData(res.data);
            //         }
            //       });
            //     setParent(folder);
            //     setQueryId(folder);
            //   } else if (folder?.name === "RECENTLY RUN") {
            //     setSorting({ ...sorting, sort: "lastRunDate", sortDir: "DESC" });
            //     setInitialFilters({ ...initialFilters, scheduled: undefined });

            //     setQueryType(undefined);
            //     setParent(folder);
            //     setQueryId(folder);

            //     sorting?.sort === "lastRunDate" &&
            //       sorting?.sortDir === "DESC" &&
            //       refetchAllQueries().then((res) => {
            //         if ("data" in res && res.data?.searchTemplates) {
            //           setQueriesData(res.data);
            //         }
            //       });
            //   } else if (folder?.name === "SCHEDULED") {
            //     setSorting({ ...sorting, sort: undefined, sortDir: undefined });
            //     setQueryType(undefined);
            //     setInitialFilters({ ...initialFilters, scheduled: true });
            //     setParent(folder);
            //     setQueryId(folder);

            //     initialFilters?.scheduled === true &&
            //       refetchAllQueries().then((res) => {
            //         if ("data" in res && res.data?.searchTemplates) {
            //           setQueriesData(res.data);
            //         }
            //       });
            //   } else if (folder?.name === "SYSTEM") {
            //     setSorting({ ...sorting, sort: undefined, sortDir: undefined });
            //     setInitialFilters({ ...initialFilters, scheduled: undefined });

            //     setParent(folder);
            //     setQueryId(folder);
            //     setQueryType("SYSTEM");

            //     queryType === "SYSTEM" &&
            //       refetchAllQueries().then((res) => {
            //         if ("data" in res && res.data?.searchTemplates) {
            //           setQueriesData(res.data);
            //         }
            //       });
            //   } else {
            //     handleClick();
            //     setParent(folder);
            //     // setQueryType(undefined) // no need here
            //   }
            // }}
            onClick={() => {
              if (isDisabled) return;

              let updatedSorting = { ...sorting };
              let updatedFilters = { ...initialFilters };
              let updatedQueryType: string | undefined = undefined;
              let shouldRefetch = false;

              switch (folder?.name) {
                case "ALL QUERIES":
                  setActiveSource("ALL");
                  updatedSorting = { sort: undefined, sortDir: undefined };
                  updatedFilters.scheduled = undefined;
                  updatedQueryType = undefined;
                  shouldRefetch = true;
                  break;

                case "RECENTLY RUN":
                  setActiveSource("ALL");
                  updatedSorting = { sort: "lastRunDate", sortDir: "DESC" };
                  updatedFilters.scheduled = undefined;
                  updatedQueryType = undefined;
                  shouldRefetch = true;
                  break;

                case "SCHEDULED":
                  setActiveSource("ALL");
                  updatedSorting = { sort: undefined, sortDir: undefined };
                  updatedFilters.scheduled = true;
                  updatedQueryType = undefined;
                  shouldRefetch = true;
                  break;

                case "SYSTEM":
                  setActiveSource("ALL");
                  updatedSorting = { sort: undefined, sortDir: undefined };
                  updatedFilters.scheduled = undefined;
                  updatedQueryType = "SYSTEM";
                  shouldRefetch = true;
                  break;

                default:
                  setActiveSource("FOLDER");
                  handleClick();
                  shouldRefetch = false;
                  break;
              }

              setSorting(updatedSorting);
              setInitialFilters(updatedFilters);
              setQueryType(updatedQueryType);
              setParent(folder);
              setQueryId(folder);

              if (shouldRefetch) {
                refetchAllQueries();
                // refetchAllQueries().then((res) => {
                //   if (res.data) {
                //     setQueriesData(res.data);
                //   }
                // });
              }
            }}

          >
            <FolderIcon color={theme.CorporateTheme.colors.headerColor} />
            <StyledText
              fontSize="14px"
              fontWeight={500}
              textColor={theme.CorporateTheme?.colors?.headerColor}
            >
              {capitalizeFirstLetter(folder?.name)}
            </StyledText>
          </div>
          <div className="d-flex align-items-center gap-2">
            {folder.name !== "ALL QUERIES" &&
              folder.name !== "RECENTLY RUN" &&
              folder.name !== "SYSTEM" &&
              folder.name !== "SCHEDULED" ? (
              <div className="position-relative">
                <OpitonsIcon color={theme.CorporateTheme.colors.textSecondary} onClick={toggleOptions} />
                {isOptionOpen && (
                  <FolderOptions
                    theme={theme}
                    ref={optionsRef}
                    className=" rounded d-flex flex-column  py-2"
                  >
                    {Options?.map((opt, ind) => (
                      <SingleOption
                        theme={theme}
                        key={ind}
                        className="d-flex align-item-center justify-content-between px-3 py-1"
                        onClick={() => {
                          opt?.handler(folder);
                        }}
                      >
                        <StyledText
                          fontSize="13px"
                          fontWeight={500}
                          textColor={theme.CorporateTheme.colors.headerColor}
                        >{opt?.name}</StyledText>
                        {opt.icon}
                      </SingleOption>
                    ))}
                  </FolderOptions>
                )}
              </div>
            ) : null}
            {/* Right side: Chevron */}
            {hasChildren ? (
              <ChevronWrapper $isOpen={isOpen} onClick={toggleOpen}>
                <ChevronDownIcon color={theme.CorporateTheme.colors.textSecondary} />
              </ChevronWrapper>
            ) : (
              <span className="invisible" style={{ width: "1rem" }} /> // keeps spacing consistent
            )}
          </div>
        </StyledFolderBar>

        {/* Children */}
        {hasChildren && isOpen ? (
          <div className="ms-4">
            {(level === 1 ? folder?.grandChildren : folder?.children)
              ?.filter((child) => !child?.isDeleted)
              ?.map((child) => (
                <FolderItem
                  key={child.id}
                  folder={child}
                  queryId={queryId}
                  setQueryId={setQueryId}
                  getQueriesCall={getQueriesCall}
                  openFolders={openFolders}
                  setOpenFolders={setOpenFolders}
                  openOptions={openOptions}
                  setOpenOptions={setOpenOptions}
                  level={level + 1}
                  parentFolder={folder}
                  isDisabled={isDisabled}
                />
              ))}
          </div>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    if (activeSource === "ALL" && queries?.searchTemplates) {
      setQueriesData(queries);
    }
  }, [queries, activeSource]);

  useEffect(() => {
    if (folders) {
      const preDefinedFolder = [
        {
          id: 786,
          name: "ALL QUERIES",
          type: "ALL QUERIES",
          parentFolderId: null,
          children: [],
        },
        {
          id: Math.floor(Math.random() * 1000),
          name: "SCHEDULED",
          type: "SCHEDULED",
          parentFolderId: null,
          children: [],
        },
        // {
        //   id: Math.floor(Math.random() * 1000),
        //   name: "RECENTLY RUN QUERIES",
        //   type: "RECENTLY RUN QUERIES",
        //   parentFolderId: null,
        //   children: [],
        // },
      ];

      const systemFolder = [
        {
          id: Math.floor(Math.random() * 1000),
          name: "SYSTEM",
          type: "SYSTEM",
          parentFolderId: null,
          children: [],
        },
      ];
      setFolderData({
        queryFolders: [
          ...preDefinedFolder,
          ...(folders?.queryFolders ?? []),
          ...systemFolder,
        ],
      });
      dispatch(setQueryFolders({ folders: folders?.queryFolders ?? [] }));
    }
  }, [folders]);

  useEffect(() => {
    if (paramID) {
      getQueriesCall(String(paramID));
    }
  }, [paramID]);

  const FolderInitialValues = {
    name: updateFolder ? updateFolder?.name : "",
    parentFolderId: parent?.name,
  };



  const addFolderSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    parentFolderId: Yup.string().required("Required"),
  });

  function getUniqueFolderName(
    folders: any[],
    parentFolderId: number | null,
    desiredName: string
  ): string {
    const nameRegex = new RegExp(`^${desiredName}(\\s\\((\\d+)\\))?$`, "i");

    const findSiblingsByParentId = (folders: any[]): any[] => {
      for (const folder of folders) {
        if (folder.id === parentFolderId) {
          return folder.children || folder.grandChildren || [];
        }

        const inChildren = folder.children
          ? findSiblingsByParentId(folder.children)
          : [];
        if (inChildren.length) return inChildren;

        const inGrandChildren = folder.grandChildren
          ? findSiblingsByParentId(folder.grandChildren)
          : [];
        if (inGrandChildren.length) return inGrandChildren;
      }
      return [];
    };

    const siblings: any[] =
      parentFolderId === null
        ? folders.filter((f) => f.parentFolderId === null)
        : findSiblingsByParentId(folders);

    let maxCount = 0;
    siblings.forEach((f) => {
      const match = f.name.match(nameRegex);
      if (match) {
        const num = match[2] ? parseInt(match[2]) : 1;
        if (num > maxCount) maxCount = num;
      }
    });

    if (maxCount === 0) return desiredName;
    return `${desiredName} (${maxCount + 1})`;
  }

  const handleSubmit = (values: any) => {
    const call = updateFolder ? updateFolderName : addNewFolder;
    const uniqueName = getUniqueFolderName(
      folderData?.queryFolders ?? [],
      parent?.id ?? null,
      values?.name
    );
    const val = {
      name: uniqueName,
      parentFolderId: parent?.id,
      id: updateFolder ? updateFolder?.id : undefined,
    };

    call(val)
      .unwrap()
      .then((res) => {
        if (res?.error) {
          showToast(
            "Action Failed",
            `${updateFolder
              ? "Failed to update folder"
              : "Failed to add new folder"
            }`,
            "error"
          );

          return;
        }
        showToast(
          ` Folder ${updateFolder ? "Updated" : "Created"}`,
          `${updateFolder
            ? "Folder has been updated"
            : "New Folder has been created."
          }`,
          "success"
        );
        setParent(null);
        setCreateNewFolder(false);
        setUpdateFolder(null);
        setQueryId(null);
        refetch && refetch();
      });
  };

  const handelCloneQuery = async (id: number) => {
    // const numericId = Number(id);
    try {
      const clone = await cloneQuery(id);
      if (clone) {
        refetch();
        showToast(
          "Query Cloned",
          "The query is cloned successfully.",
          "success"
        );
        refetchAllQueries();
        refetch && refetch();
      }
    } catch {
      showToast(
        "Clone Failed",
        "Failed to clone query. Please try again.",
        "error"
      );
    }
  };

  const confirmDelete = async () => {
    const numericId = Number(queryId?.id);
    try {

      const data = await deleteQueryFolder(numericId);
      if (data) {
        refetch();
        showToast(
          "Query Folder Deleted",
          "The selected query folder has been deleted.",
          "success"
        );
        setShowDeletePrompt(false);
        // setQueryId(null);
        // setParent(null);
        // setCreateNewFolder(false);
        // refetchAllQueries();
        // refetch && refetch();

        if (parent) {
          // Select parent folder instead of ALL QUERIES
          setQueryId(parent);
          setActiveSource("FOLDER");
          getQueriesCall(parent.id, queriesData.page, queriesData.perPage);
        } else {
          // Root folder deleted → clear selection safely
          setQueryId(null);
          setActiveSource("ALL");
          setQueryId({
            id: 786,
            name: "ALL QUERIES",
            type: "ALL QUERIES",
            parentFolderId: null,
            children: [],
          });
        }

        setParent(null);
        setCreateNewFolder(false);
        refetchAllQueries();
        refetch();
      }
    } catch {
      showToast(
        "Delete Failed",
        "Failed to delete query folder. Please try again.",
        "error"
      );
    }
  };

  const confirmDeleteQuery = async () => {
    const numericId = Number(deleteQueryId?.deleteId);
    try {
      const { data }: any = await deleteQuery(numericId);
      if (data) {
        refetch();
        refetchAllQueries();
        showToast(
          "Query Deleted",
          "The selected query has been deleted.",
          "success"
        );
        setShowDeleteQueryPrompt(false);
        // paramID && getQueriesCall(deleteQueryId?.folderId);
        if (activeSource === "FOLDER" && queryId?.id) {
          getQueriesCall(queryId.id, queriesData.page, queriesData.perPage);
        }

        if (activeSource === "ALL") {
          refetchAllQueries();
        }

        // Always refetch folders (counts, structure, etc.)
        refetch();
      }
    } catch {
      showToast(
        "Delete Failed",
        "Failed to delete query. Please try again.",
        "error"
      );
    }
  };

  return (
    <div
      style={{
        backgroundColor: CorporateTheme?.colors?.filterBG,
        position: "relative",
      }}
    >
      <ComponentHeader
        title="Member Things Queries"
        totalItems={
          (queriesData?.searchTemplates ?? [])?.length > 0
            ? Number(queriesData?.totalCount) ?? 0
            : 0
        }
        subtitle="All saved search queries will show here"
        routeKey="QueryFoldersListing"
        queryFilters={queryId?.name === "ALL QUERIES"}
        setInitialFilters={setInitialFilters}
        isBorder={true}
        disabled={
          // queriesData?.searchTemplates?.length === 0 ||
          folderData?.queryFolders?.length === 0 ||
          foldersLoading || queryLoading}
        filterDisabled={foldersLoading || queryLoading}
      />
      <div
        className="row no-gutters"
        style={
          {
            "--bs-gutter-x": "0",
            height: "calc(100vh - 190px)",
          } as React.CSSProperties
        }
      >
        <Col lg={3}>
          <div
            className="d-flex flex-column"
            style={{
              height: "calc(100vh - 190px)",
              backgroundColor: theme.CorporateTheme.colors.background,
              // border: `1px solid ${theme.CorporateTheme.colors.border}`
            }}
          >
            <div className="d-flex align-items-center justify-content-between p-3 pb-1">
              <div className="d-flex align-items-center gap-2">
                <StyledText
                  fontSize="16px"
                  fontWeight={600}
                  textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                  Query Folders
                </StyledText>

                {/* <StyledText
                  fontSize="16px"
                  fontWeight={600}
                  textColor={theme.CorporateTheme?.colors?.count}
                  style={{ fontFamily: "Lato, sans-serif" }}
                >
                  ({folders?.totalCount})
                </StyledText> */}
              </div>
              <div className="position-relative">
                { }
                {/* <AddFolderIcon
                  className={`cursor-pointer ${!queryId && "class-disable "} `}
                  onClick={() => setCreateNewFolder(!createNewFolder)}
                /> */}
                {createNewFolder && (
                  <StyledNewFolder
                    theme={theme}
                    className="rounded d-flex flex-column justify-content-center"
                    ref={createNewFolderRef}
                  >
                    <div
                      style={{
                        backgroundColor: theme.CorporateTheme.colors?.lightNavy,
                      }}
                      className="rounded-top p-4 py-3"
                    >
                      <StyledText
                        fontSize="16px"
                        fontWeight={700}
                        textColor="#fff"
                      >
                        {updateFolder ? "Update" : "Create new"} folder
                      </StyledText>
                    </div>

                    <Formik
                      initialValues={FolderInitialValues}
                      enableReinitialize
                      validationSchema={addFolderSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        handleSubmit,
                        setFieldValue,
                        values,
                        touched,
                        errors,
                      }) => (
                        <Form onSubmit={handleSubmit}>
                          <div className="d-flex  flex-column rounded-md dark:border-textColor rounded  overflow-y-auto" style={{ backgroundColor: theme.CorporateTheme.colors.background }}>
                            <div className="px-4 py-5 w-100">
                              <div className="mt-0 mb-4 ">
                                <StyledText
                                  className=" mb-2"
                                  textColor={
                                    theme.CorporateTheme?.colors?.headerColor
                                  }
                                >
                                  Folder Name{" "}
                                  <span className="text-danger ">*</span>
                                </StyledText>
                                <FormikInputField
                                  name="name"
                                  type="text"
                                  placeholder="Enter folder name"
                                />
                              </div>

                              <div className="mt-4">
                                <StyledText
                                  className=" mb-2"
                                  textColor={
                                    theme.CorporateTheme?.colors?.headerColor
                                  }
                                >
                                  Selected Parent{" "}
                                  <span className="text-danger ">*</span>
                                </StyledText>{" "}
                                <FormikInputField
                                  name="parentFolderId"
                                  disabled
                                  placeholder="Select parent here"
                                />
                              </div>
                              <div className="d-flex align-items-center justify-content-end mt-4">
                                <div className="d-flex gap-1">
                                  <Button
                                    theme={theme}
                                    type="button"
                                    className={`cursor-pointer ${updateFolderLoading || addFolderLoading
                                      ? "disabled"
                                      : ""
                                      }`}
                                    $variant="cancel"
                                    onClick={() => {
                                      setCreateNewFolder(false);
                                      setParent(null);
                                      setUpdateFolder(null);
                                    }}
                                  >
                                    <CrossIcon size={18} color={theme.CorporateTheme.colors.headerColor} />
                                    Cancel
                                  </Button>
                                  <Button
                                    theme={theme}
                                    type="submit"
                                    $variant="add"
                                    className="cursor-ponter"
                                  >
                                    {addFolderLoading || updateFolderLoading ? (
                                      <>
                                        <label>{updateFolder ? "Updating..." : "Creating..."}</label>
                                        <LoadingCircleIcon />
                                      </>
                                    ) : (
                                      <div className="d-flex align-items-center gap-1 cursor-pointer">
                                        <FormsIcon size={18} color={theme.CorporateTheme.colors.background} />
                                        <label className="cursor-pointer">
                                          {updateFolder ? " Update" : " Create"}
                                        </label>
                                      </div>
                                    )}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </StyledNewFolder>
                )}
              </div>
            </div>
            <StyledHorizontalLine theme={theme} className="mt-3 mx-3" />

            {isFetching ? (
              <>
                <div className="d-flex flex-column gap-1 px-2 mt-3">
                  {Array(5)
                    .fill(null)
                    .map((_, i) => (
                      <SkeletonCell
                        key={i}
                        style={{
                          maxWidth: "100%",
                          height: "40px",
                          marginBottom: "10px",
                        }}
                      />
                    ))}
                </div>
              </>
            ) : (
              folderData?.queryFolders?.map((folder: QueryFolder) => (
                <FolderItem
                  key={folder.id}
                  folder={folder}
                  queryId={queryId}
                  setQueryId={setQueryId}
                  getQueriesCall={getQueriesCall}
                  openFolders={openFolders}
                  setOpenFolders={setOpenFolders}
                  openOptions={openOptions}
                  setOpenOptions={setOpenOptions}
                  level={0}
                  isDisabled={isFetchingData}
                />
              ))
            )}
          </div>
        </Col>
        <Col lg={9} className="d-flex flex-column gap-2 p-3 " style={{ backgroundColor: theme.CorporateTheme.colors.darkLightBG }}>
          <div style={{ height: "calc(100vh - 290px)", overflowY: "auto" }} >
            <SimpleBar
              autoHide={false}
              className="pe-2"
            // className="overflow-y-auto"

            >
              {queryLoading || allQueriesFetching ? (
                <div className="d-flex flex-column gap-1 px-2 mt-3">
                  {Array(7)
                    .fill(null)
                    .map((_, i) => (
                      <StyledQueryResult theme={theme} key={i}>
                        <SkeletonCell
                          style={{
                            maxWidth: "100%",
                            height: "100px",
                            marginBottom: "5px",
                          }}
                        />
                      </StyledQueryResult>
                    ))}
                </div>
              ) : (queriesData?.searchTemplates ?? [])?.length > 0 ? (
                queriesData?.searchTemplates?.map((temp, ind) => {
                  const isOwner = temp.createdBy === userID;

                  return (
                    // <StyledQueryResult theme={theme} key={ind}>
                    //   <Row className="p-3 pb-0 mx-0">
                    //     <Col lg={2}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //       >
                    //         Object Name
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //       >
                    //         Query Name
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Record Count
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Created by
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Last Run Date
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Created Date
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Last Modified At
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1}>
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={600}
                    //         textColor={theme.CorporateTheme?.colors?.headerColor}
                    //         className="text-center"
                    //       >
                    //         Action
                    //       </StyledText>
                    //     </Col>
                    //   </Row>
                    //   <StyledHorizontalLine theme={theme} className="mt-3" />
                    //   <Row className="p-3 pt-0 mx-0">
                    //     <Col lg={2} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //       >
                    //         {temp?.scope}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //       >
                    //         {temp?.name}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //         className="text-center"
                    //         fontFamily={font.lato}
                    //       >
                    //         {temp?.totalRecords}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //         className="text-center"
                    //         fontFamily={font.lato}
                    //       >
                    //         {temp?.createdByAccount?.firstName}{" "}{temp?.createdByAccount?.lastName}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //         className="text-center"
                    //       >
                    //         {temp?.lastRunDate ?
                    //           // ? new Date(
                    //           //   temp?.lastRunDate ?? ""
                    //           // ).toLocaleDateString("en-US", {
                    //           //   year: "numeric",
                    //           //   month: "long",
                    //           //   day: "numeric",
                    //           // })
                    //           formatDateDefault(temp?.lastRunDate ?? "")
                    //           : "-"}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //         className="text-center"
                    //       >
                    //         {
                    //         // new Date(temp?.createdAt ?? "").toLocaleDateString(
                    //         //   "en-US",
                    //         //   {
                    //         //     year: "numeric",
                    //         //     month: "long",
                    //         //     day: "numeric",
                    //         //   }
                    //         // )
                    //         formatDateDefault(temp?.createdAt ?? "")
                    //         }
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={2} className="align-self-center">
                    //       <StyledText
                    //         fontSize="13px"
                    //         fontWeight={500}
                    //         textColor={theme.CorporateTheme?.colors?.textSecondary}
                    //         className="text-center"
                    //       >
                    //         {temp?.updatedAt ?
                    //           // ? new Date(temp?.updatedAt ?? "").toLocaleDateString(
                    //           //     "en-US",
                    //           //     {
                    //           //       year: "numeric",
                    //           //       month: "long",
                    //           //       day: "numeric",
                    //           //     }
                    //           //   )
                    //             formatDateDefault(temp?.updatedAt ?? "")
                    //           : "-"}
                    //       </StyledText>
                    //     </Col>
                    //     <Col lg={1} className="align-self-center">
                    //       <div className="d-flex gap-2 align-items-center justify-content-center">
                    //         {/* <ShareLinkIcon className="cursor-pointer" /> */}
                    //         <div style={{
                    //           opacity: temp.createdBy === userID ? 1 : 0.5,
                    //         }}>
                    //           <EditIcon
                    //             color={theme.CorporateTheme.colors.gunmetal}
                    //             className="cursor-pointer"
                    //             size={18}
                    //             onClick={() =>{
                    //               if (temp.createdBy === userID) {
                    //                 navigate(
                    //                   `/home/search-query/query-preview/${temp?.id}`,
                    //                   { state: { item: temp } }
                    //                 );
                    //               }
                    //             }}
                    //           />
                    //         </div>

                    //         <div title={"clone"}>
                    //           <CopyIcon 
                    //             color={theme.CorporateTheme.colors.textSecondary}
                    //             className="cursor-pointer"
                    //             size={18}
                    //             onClick={() => handelCloneQuery(temp.id)}
                    //           />
                    //         </div>

                    //         <div style={{
                    //           opacity: temp.createdBy === userID ? 1 : 0.5,
                    //         }}>
                    //           <DeleteIcon
                    //             color={theme.CorporateTheme.colors.gunmetal}
                    //             className={temp.createdBy === userID ? "cursor-pointer" : 'auto'}
                    //             size={18}
                    //             onClick={() => {
                    //               if (temp.createdBy === userID) {
                    //                 setShowDeleteQueryPrompt(true);
                    //                 setDeleteQueryId({
                    //                   deleteId: temp?.id,
                    //                   folderId: temp?.folderId,
                    //                 });
                    //               }
                    //             }}
                    //           />
                    //         </div>
                    //       </div>
                    //     </Col>
                    //     {/* </Row> */}
                    //     <div
                    //       className="p-2 d-flex align-items-center justify-content-between mt-3"
                    //       style={{
                    //         backgroundColor: theme.CorporateTheme?.colors?.filterBG,
                    //         borderRadius: "5px",
                    //       }}
                    //     >
                    //       {temp?.description ? (
                    //         <div className="d-flex gap-2">
                    //           <StyledText
                    //             fontSize="13px"
                    //             fontWeight={600}
                    //             textColor={theme.CreateFormTheme.colors.primaryBtn}
                    //           >
                    //             Description:
                    //           </StyledText>
                    //           <StyledText
                    //             fontSize="14px"
                    //             fontWeight={500}
                    //             textColor={theme.CorporateTheme.colors.secondary}
                    //           >
                    //             {temp?.description}
                    //           </StyledText>
                    //         </div>
                    //       ) : (
                    //         <div></div>
                    //       )}
                    //       <div className="d-flex align-items-center gap-4">
                    //         <div>
                    //           <ClockIcon
                    //           className={`${temp?.meta?.isEnabled && 'text-primary'} cursor-pointer`}
                    //           onClick={() => {
                    //             setScheduledModal(true);
                    //             setQueryName(temp?.name);
                    //             setScheduleId(temp?.id);
                    //           }}
                    //         />
                    //         </div>

                    //         <div>
                    //           <Button
                    //           theme={theme}
                    //           type="submit"
                    //           $variant="add"
                    //           width="143px"
                    //           onClick={() =>
                    //             navigate(
                    //               `/home/search-query/query-preview/${temp?.id}`,
                    //               {
                    //                 state: { item: temp, runImmediately: temp?.queryPayload ? true : false },
                    //               }
                    //             )
                    //           }
                    //         >
                    //           <div><FormsIcon color={theme.CorporateTheme.colors.background} /></div>
                    //           Run Query
                    //         </Button>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </Row>
                    // </StyledQueryResult>
                    <StyledCard theme={theme}>
                      {/* ── Title row ── */}
                      <TitleRow>
                        <TitleLeft>
                          {temp?.scope && (
                            <Badge borderRadius="4px" bgColor={hexToRgba(theme.CorporateTheme.colors.oceanBlue, 0.1)} color={theme.CorporateTheme.colors.oceanBlue} text={capitalizeFirstLetter(temp?.scope)} fontSize="12px" fontWeight={500} padding="6px 8px" />

                          )}


                          {(
                            temp?.scheduledQuery?.nextExecutionDate ||
                            temp?.scheduledQuery?.lastRunDate
                          ) && (
                              <Badge
                                borderColor="none"
                                padding="7px 8px"
                                bgColor={hexToRgba(theme.CorporateTheme.colors.melonYellow, 0.2)}
                                color={theme.CorporateTheme.colors.primary}
                                fontSize="10px"
                                fontStyle="italic"
                                fontWeight={600}
                                text={getScheduleBadgeLabel(temp)}
                                borderRadius="3px"
                              />
                            )}
                          {temp?.scheduledQuery?.nextExecutionDate && (
                            <NextDateBadge theme={theme}>
                              <CalendarIcon size={16} color={theme.CorporateTheme.colors.headerColor} strokeWidth={1} strokeWidth2={1.3} />
                              <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                                Next run: {formatDateDefault(temp?.scheduledQuery?.nextExecutionDate)} {temp?.scheduledQuery?.scheduleSettings && (
                                  <>{`(${formatScheduleLabel(temp?.scheduledQuery?.scheduleSettings)})`}</>
                                )}
                              </StyledText>
                            </NextDateBadge>
                          )}
                        </TitleLeft>

                        <ActionsRow>
                          {/* Edit */}
                          <IconWrapper
                            theme={theme}
                            $disabled={!isOwner}
                            onClick={() => {
                              if (isOwner) {
                                navigate(`/home/search-query/query-preview/${temp?.id}`, {
                                  state: { item: temp },
                                });
                              }
                            }}
                          >
                            <EditIcon
                              color={theme.CorporateTheme.colors.headerColor}
                              size={19}
                              strokeWidth={1.27}
                            />
                          </IconWrapper>

                          {/* Clone */}
                          <IconWrapper
                            theme={theme}
                            title="clone"
                            onClick={() => handelCloneQuery(temp.id)}
                          >
                            <NewCopyIcon
                              color={theme.CorporateTheme.colors.headerColor}
                              size={18}
                              strokeWidth={1.27}
                            />
                          </IconWrapper>

                          {/* Schedule */}
                          <IconWrapper
                            theme={theme}
                            onClick={() => {
                              setScheduledModal(true);
                              setQueryName(temp?.name);
                              setScheduleId(temp?.id);
                            }}
                            style={{ color: temp?.meta?.isEnabled ? "#3b82f6" : undefined }}
                          >
                            <ClockIcon size={18} color={theme.CorporateTheme.colors.headerColor} strokeWidth={1.27} />
                          </IconWrapper>

                          {/* Delete */}
                          <IconWrapper
                            theme={theme}
                            $disabled={!isOwner}
                            onClick={() => {
                              if (isOwner) {
                                setShowDeleteQueryPrompt(true);
                                setDeleteQueryId({
                                  deleteId: temp?.id,
                                  folderId: temp?.folderId,
                                });
                              }
                            }}
                          >
                            <DeleteIcon
                              color={theme.CorporateTheme.colors.headerColor}
                              size={18}
                              strokeWidth={1.27}
                            />
                          </IconWrapper>

                          {/* Run */}
                          {/* <RunButton
                          theme={theme}
                          onClick={() =>
                            navigate(`/home/search-query/query-preview/${temp?.id}`, {
                              state: {
                                item: temp,
                                runImmediately: temp?.queryPayload ? true : false,
                              },
                            })
                          }
                        >
                          <FormsIcon color="#fff" size={14} />
                          Run
                        </RunButton> */}
                          <Button
                            theme={theme}
                            btnBg={theme?.CreateFormTheme?.colors?.primaryBtn}
                            color={theme?.CorporateTheme?.colors?.background}
                            type="button"
                            $variant="customButton"
                            width="86px"
                            height="40px"
                            gap="4px"
                            borderColor="none"
                            className="ps-2 pe-2"
                            radius="3px"
                            onClick={() =>
                              navigate(`/home/search-query/query-preview/${temp?.id}`, {
                                state: {
                                  item: temp,
                                  runImmediately: temp?.queryPayload ? true : false,
                                },
                              })
                            }
                          >
                            <div className="mb-1"><PlayIcon color={theme?.CorporateTheme?.colors?.background} /></div>
                            Run
                          </Button>
                        </ActionsRow>
                      </TitleRow>

                      {/* ── Description ── */}
                      <StyledText className={!temp?.description ? 'mb-3' : 'mb-0'} textColor={theme.CorporateTheme.colors.headerColor} fontSize="16px" fontWeight={600}>
                        {temp?.name}
                      </StyledText>
                      {temp?.description && (
                        <StyledText fontSize="13px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={400} className="mt-2 mb-3">{temp?.description}</StyledText>
                      )}

                      {/* ── Meta row ── */}
                      <MetaRow theme={theme}>
                        {/* Created at */}
                        {temp?.createdAt && (
                          <MetaItem theme={theme}>
                            <CalendarIcon size={16} color={theme.CorporateTheme.colors.headerColor} strokeWidth={1} strokeWidth2={1.3} />
                            <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                              Created at: {formatDateDefault(temp?.createdAt)}
                            </StyledText>
                          </MetaItem>
                        )}

                        {/* last modified*/}
                        {temp?.updatedAt && (
                          <MetaItem theme={theme}>
                            <EditCalendarIcon size={16} color={theme.CorporateTheme.colors.headerColor}/>
                            <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                              Last modified: {formatDateDefault(temp?.updatedAt)}
                            </StyledText>
                          </MetaItem>
                        )}

                         {/* last query run*/}
                        {temp?.lastRunDate && (
                          <MetaItem theme={theme}>
                            <SearchCalendarIcon size={16} color={theme.CorporateTheme.colors.headerColor}/>
                            <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                              Last query run: {formatDateDefault(temp?.lastRunDate)}
                            </StyledText>
                          </MetaItem>
                        )}

                        {/* Last run */}
                        {temp?.scheduledQuery?.lastRunDate && (
                          <MetaItem theme={theme}>
                            <CalendarIcon size={16} color={theme.CorporateTheme.colors.headerColor} strokeWidth={1} strokeWidth2={1.3} />
                            <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                              Last scheduled run: {formatDateDefault(temp?.scheduledQuery?.lastRunDate)}
                            </StyledText>
                          </MetaItem>
                        )}

                        {/* Record count */}
                        <MetaItem theme={theme}>
                          <CheckListIcon color={theme.CorporateTheme.colors.headerColor} />
                          <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                            {temp?.totalRecords ?? 0} Records
                          </StyledText>
                        </MetaItem>

                        
                          {temp?.createdByAccount && (
                          <MetaItem theme={theme}>
                            <OutlineUserIcon size={16} color={theme.CorporateTheme.colors.headerColor}/>
                            <StyledText fontSize="12px" textColor={theme.CorporateTheme.colors.textSecondary} fontWeight={500} fontFamily={font.lato}>
                              Created By: {temp?.createdByAccount?.firstName}{" "}{temp?.createdByAccount?.lastName}
                            </StyledText>
                          </MetaItem>
                        )}





                      </MetaRow>
                    </StyledCard>
                  )
                })
              ) : (
                <>
                  <NoData
                    title={"No Data Found"}
                    subtitle={"No data available for the search queries."}
                  />
                </>
              )}
            </SimpleBar>
          </div>
          {queriesData?.searchTemplates?.length &&
            queriesData.searchTemplates.length > 0 ? (
            <Pagination
              className="mt-2 py-1 px-3"
              currentPage={queriesData?.page ?? 1}
              totalItems={queriesData?.totalCount ?? 0}
              perPage={queriesData?.perPage ?? 0}
              totalPages={totalPages}

              onPageChange={(page) => {
                setQueriesData((prev) => ({ ...prev, page }));
              }}
              onLimitChange={(limit) => {
                setQueriesData((prev) => ({ ...prev, perPage: limit, page: 1 }));
              }}
            />
          ) : (
            ""
          )}
        </Col>
        {/* {data?.length > 0 && ( */}

        {/* )} */}

        {showDeletePrompt && (
          <DeletePrompt
            onConfirm={confirmDelete}
            onCancel={() => {
              setShowDeletePrompt(false);
              setParent(null);
            }}
            loading={folderDeleteLoading}
          />
        )}

        {scheduledModal && (
          <ScheduleQueryModal
            onClose={() => {
              setScheduledModal(false);
            }}
            refetch={refetchAllQueries}
            name={queryName}
            id={scheduleId}
          />
        )}

        {showDeleteQueryPrompt && (
          <DeletePrompt
            onConfirm={confirmDeleteQuery}
            onCancel={() => {
              setShowDeleteQueryPrompt(false);
              setParent(null);
            }}
            loading={queryDeleteLoading}
          />
        )}
        {/* <QueryScopeModal onClose={() => {}} /> */}
      </div>
    </div>
  );
};

// Add this CSS to your global stylesheet or a CSS module imported in this file
// .custom-gutter-x-0 {
//   --bs-gutter-x: 0;
// }

export default QueryFoldersListing;

const StyledFolderBar = styled('div')(({ theme }) => ({
  '&:hover, &.active': {
    borderLeft: `4px solid ${theme.CorporateTheme.colors.primary}`,
    backgroundColor: theme.CorporateTheme.colors.headerBG,
    borderRadius: '4px',
  },
}));

const StyledQueryResult = styled('div')(({ theme }) => ({
  backgroundColor: theme.CorporateTheme.colors.background,
  borderRadius: '8px',
  marginBottom: '10px',
}));

const StyledNewFolder = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '327px',
  backgroundColor: theme.CorporateTheme.colors.background,
  left: '19px',
  top: '-25px',
  zIndex: 99999,
  boxShadow: '-4px 4px 40px 0px #0000001A',
}));

const FolderOptions = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '180px',
  backgroundColor: theme.CorporateTheme.colors.background,
  left: '25px',
  top: '-15px',
  zIndex: 99,
  // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  boxShadow: "-4px 4px 40px 0px #0000001A"

}));

const StyledCard = styled.div`
  background: ${({ theme }) => theme.CorporateTheme?.colors?.background || "#fff"};
  border-radius: 8px;
  padding:20px;
  margin-bottom: 12px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
`;

const TitleLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
`;

const ScopeBadge = styled.span`
  background: ${({ theme }) => theme.CorporateTheme?.colors?.filterBG || "#f0f4ff"};
  color: ${({ theme }) => theme.CorporateTheme?.colors?.primaryBtn || "#3b5bdb"};
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const QueryTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.CorporateTheme?.colors?.headerColor || "#1a1a2e"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ScheduledBadge = styled.span`
  background: #fff7e6;
  color: #d97706;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
`;

const IconWrapper: any = styled.div<{ $disabled?: boolean; theme?: any }>`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
  color: ${(props) => props.theme?.CorporateTheme?.colors?.gunmetal || "#4b5563"};
  transition: opacity 0.15s;

  &:hover {
    opacity: ${(props) => (props.$disabled ? 0.4 : 0.7)};
  }
`;

const RunButton = styled.button`
  background: ${({ theme }) => theme.CorporateTheme?.colors?.primaryBtn || "#1d4ed8"};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
 
  &:hover {
    background: ${({ theme }) => theme.CorporateTheme?.colors?.primaryBtnHover || "#1e40af"};
  }
`;

const Description = styled.p`
  margin: 6px 0 10px;
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.CorporateTheme?.colors?.textSecondary || "#6b7280"};
  line-height: 1.4;
`;

const MetaRow = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  border-top: 1px solid ${({ theme }) => theme.CorporateTheme?.colors?.border};
  padding-top: 15px;
  margin-top: 4px;
`;

const NextDateBadge = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${({ theme }) => theme.CorporateTheme.colors.builderBg};
  padding: 6px 8px;
  border-radius: 4px;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.CorporateTheme?.colors?.textSecondary || "#6b7280"};
`;


const SingleOption = styled('div')(({ theme }) => ({
  '&:hover': {
    background: theme.CorporateTheme.colors.filterBG,
  },
}));
